module.exports = __webpack_public_path__ + "img/stock13.6a09d801.png";